/**
 * Compute the OnboardingRail "Done so far" state from /me.
 *
 * Rule (locked 2026-05-22): milestones light on **actual completion**, NOT
 * on skip. Skipped milestones stay unlit; the dashboard DashboardBanners
 * carries the "come back and finish this" reminder elsewhere.
 *
 * Maps:
 *   accountCreated  → always true (signup is prereq for reaching onboarding)
 *   profileDone     → me.memberships.length > 0 (client row exists)
 *   snippetDone     → me.snippet_verified_at (NOT snippet_skipped_at)
 *   adsDone         → at least one ad platform actually connected (NOT skipped)
 *   whatsappDone    → me.waba_id non-null (pairing succeeded)
 *
 * See STATUS/PLAN_ONBOARDING_REDESIGN_PORT.md.
 */

import type { Me } from '@/types/auth';
import type { OnboardingRailState } from '@/components/onboarding/OnboardingRail';

export function computeRailState(me: Me | null): OnboardingRailState {
  const profileDone = !!me?.memberships && me.memberships.length > 0;
  const snippetDone = !!me?.snippet_verified_at;
  const googleConnected = !!me?.google_ads_customer_id;
  const facebookConnected = !!me?.facebook_pixel_id;
  // At least one ad platform actually connected lights the rail. Backend's
  // connect_done gates on "both addressed" (which includes skip); the rail
  // is stricter — needs a real connection to light.
  const adsDone = googleConnected || facebookConnected;
  const whatsappDone = !!me?.waba_id;

  return {
    accountCreated: true,
    profileDone,
    snippetDone,
    adsDone,
    whatsappDone,
  };
}
